import React from 'react'

import { GetLocalPublicMemberStations } from 'types/graphql'

import { Metadata, useQuery } from '@cedarjs/web'

import Card from 'src/components/Custom/Card'
import HeadingLevel from 'src/components/Custom/Heading/Heading'

import { GET_LOCAL_PUBLIC_MEMBER_STATIONS } from './queries'
import Stations from './Stations/Stations'

const GlobalStationManagerPage = () => {
  const { data: stationList, loading } = useQuery<GetLocalPublicMemberStations>(
    GET_LOCAL_PUBLIC_MEMBER_STATIONS
  )

  return (
    <div className="w-full bg-gray-100 p-4">
      <Metadata title="Stations" />
      <HeadingLevel level={1}>Stations</HeadingLevel>

      <div className="mt-5">
        {!loading && (
          <Card hideSeparator={true}>
            <Stations data={stationList} />
          </Card>
        )}
      </div>
    </div>
  )
}

export default GlobalStationManagerPage
